const localised = Intl.NumberFormat('en-GB');

export const GovernmentEvidenceTable = ({ data, mode }) => {
    const rows = {
        'Business': [
            'Comp_Hse_Company', 'AD_Name', 'VAT_Name', 'CQC_Name', 'FSA_Name', 'DVSA_Name', 'Ofsted_Name',
        ],
        'Phone': [
            'Comp_Hse_Phone', 'AD_Phone', 'VAT_Phone', 'CQC_Phone', 'FSA_Phone', 'DVSA_Phone', 'Ofsted_Phone',
        ],
        'First Seen': [
            'Comp_Hse_Inc_Date', 'AD_LF_Date', 'VAT_Insert_Date', 'CQC_Insert_Date', 'FSA_Insert_Date', 'DVSA_Insert_Date', 'Ofsted_Open_Date',
        ],
        'Last Seen': [
            'Comp_Hse_LS_Date', 'AD_Updated_Date', 'VAT_Last_Seen', 'CQC_Date_of_latest_check', 'FSA_Rating_Date', 'DVSA_Last_Seen', 'Ofsted_Last_Inspection_Date',
        ],
        'Address': [
            'Comp_Hse_Address', 'AD_Address', 'VAT_Address', 'CQC_Address', 'FSA_Address', 'DVSA_Address', 'Ofsted_Address',
        ],
    }
    return (
        <table className='table borders squish smaller-text'>
            <thead>
                <tr>
                    <th>Government Evidence</th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-companies-house fa-2x' /><span>Companies House</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-business-rates-dvsa-and-vat fa-2x' /><span>Business Rates</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-business-rates-dvsa-and-vat fa-2x' /><span>VAT</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-quality-care-commission fa-2x' /><span>Care Quality Commission</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-food-standards-agency fa-2x' /><span>Food Standards Agency</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-business-rates-dvsa-and-vat fa-2x' /><span>DVSA</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-ofsted fa-2x' /><span>Ofsted</span><span/></div></th>
                </tr>
            </thead>
            <tbody>
                {
                    renderRows(rows, data, mode)
                }
            </tbody>
        </table>
    )
}

export const MarketingEvidenceTable = ({ data, mode }) => {
    const rows = {
        'Business': [
            'Google_Company', 'BT_Name', 'JE_Company', 'TA_Name', 'Yell_Company', 'THL_Company', 'One92_Company',
        ],
        'Phone': [
            'Google_Phone', 'BT_Phone', 'JE_Phone', 'TA_Phone', 'Yell_Phone', 'THL_Phone', 'One92_Phone',
        ],
        'First Seen': [
            'Google_First_Date', 'BT_Insert_Date', 'JE_Insert_Date', 'TA_Insert_Date', 'Yell_Insert_Date', 'THL_Insert_Date', 'One92_Insert_Date',
        ],
        'Last Seen': [
            'Google_Date', 'BT_lastseen', 'JE_lastseen', 'TA_lastseen', 'Yell_lastseen', 'THL_lastseen', 'One92_lastseen',
        ],
        'Address': [
            'Google_Address', 'BT_Address', 'JE_Address', 'TA_Address', 'Yell_Address', 'THL_Address', 'One92_Address',
        ],
    }
    return (
        <table className='table borders squish smaller-text'>
            <thead>
                <tr>
                    <th>Marketing Evidence</th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-google fa-2x' /><span>Google</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-bt fa-2x' /><span>BT Directory</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-just-eat fa-2x' /><span>Just Eat</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-trip-advisor fa-2x' /><span>Trip Advisor</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-yell fa-2x' /><span>Yell</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-thomsons-local fa-2x' /><span>Thomson Local</span><span/></div></th>
                    <th><div><i className='fak fa-identeq-company-agency-icon-192 fa-2x' /><span>192</span><span/></div></th>
                </tr>
            </thead>
            <tbody>
                {
                    renderRows(rows, data, mode)
                }
            </tbody>
        </table>
    )
}

export const ExperianEvidenceTable = ({ data }) => {
    const rows = {
        'Account Name': [
            'CAIS_Merchant_Account_Name_1', 'CAIS_Current_Account_Name_1', 'CAIS_Credit_Card_Name_1', 'CAIS_Loan_Name_1', 'CAIS_Mortgages_Name_1', 'CAIS_Utilities_Name_1', 'CAIS_Telecoms_Name_1', 'CAIS_Other_Name_1',
        ],
        'Number of Accounts': [
            'CAIS_Merchant_Account_Count', 'CAIS_Current_Account_Count', 'CAIS_Credit_Card_Count', 'CAIS_Loan_Count', 'CAIS_Mortgages_Count', 'CAIS_Utilities_Count', 'CAIS_Telecoms_Count', 'CAIS_Other_Count',
        ],
        'Start Date': [
            'CAIS_Merchant_Account_start_date_1', 'CAIS_Current_Account_start_date_1', 'CAIS_Credit_Card_start_date_1', 'CAIS_Loan_start_date_1', 'CAIS_Mortgages_start_date_1', 'CAIS_Utilities_start_date_1', 'CAIS_Telecoms_start_date_1', 'CAIS_Other_start_date_1',
        ],
        'Last Seen': [
            'CAIS_Merchant_Account_lastseen_1', 'CAIS_Current_Account_lastseen_1', 'CAIS_Credit_Card_lastseen_1', 'CAIS_Loan_lastseen_1', 'CAIS_Mortgages_lastseen_1', 'CAIS_Utilities_lastseen_1', 'CAIS_Telecoms_lastseen_1', 'CAIS_Other_lastseen_1',
        ],
    }
    return (
        <table className='table borders squish smaller-text'>
            <thead>
                <tr>
                    <th>Experian</th>
                    <th>Merchant Account</th>
                    <th>Current Account</th>
                    <th>Credit Card</th>
                    <th>Loan</th>
                    <th>Mortgages</th>
                    <th>Utilities</th>
                    <th>Telecoms</th>
                    <th>Other</th>
                </tr>
            </thead>
            <tbody>
                {
                    renderRows(rows, data)
                }
            </tbody>
        </table>
    )
}

export const GoogleOpeningHoursTable = ({ data, mode }) => {
    return (
        <table className="table borders squish super-small-text extra-row-padding">
            <thead>
                <tr>
                    <th style={{textAlign: 'left'}}>
                        Days
                    </th>
                    <th>
                        Opening Times
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => {
                        return (
                            <tr>
                                <td style={{textAlign: "left", width: "100px"}}>{ day }</td>
                                <td style={{minWidth: "unset"}}>{ data?.[mode ? `${mode}_Google_Opening_Hours` : 'Google_Opening_Hours'] ? JSON.parse(data?.[mode ? `${mode}_Google_Opening_Hours` : 'Google_Opening_Hours'].replaceAll('\'', '"'))[day] : null }</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}

export const MatchingSpidDataTable = ({ data, translations, uuid }) => {
    return (
        <table className='table borders squish super-small-text extra-row-padding' >
            <thead>
                <tr>
                    <th>{translations['SPID']}</th>
                    <th>{translations['Occupier_Name']}</th>
                    <th>{translations['Client_Address']}</th>
                    <th>Total Debt</th>
                </tr>
            </thead>
            <tbody>
                {
                    data && data.Matching_Customers?.length > 0 ?
                        data.Matching_Customers.map(match => {
                            return (
                                <tr>
                                    <td>{match[uuid] || match.SPID}</td>
                                    <td>{match.Customer_Name}</td>
                                    <td>{match.CMOS_Address_Single_Line}</td>
                                    <td>{match?.Account_Balance && localised.format(match.Account_Balance)}</td>
                                </tr>
                            )
                        })
                    :
                    <tr><td/><td/><td/><td/></tr>
                }
            </tbody>
        </table>
    )
}

function renderRows(rows, data, mode) {
    const dataEntries = Object.entries(rows)
    const dataFlat = dataEntries.flat(Infinity)
    return (
        dataEntries.map(([rowLabel, columns]) => {
            return (
                <tr key={rowLabel}>
                    <td>{rowLabel}</td>
                    {columns.map((col, index) => {
                        var prefix = col.substring(0, col.indexOf('_'));
                        const prefixColumns = Object.keys(data).filter(c => {
                            return (
                                dataFlat.includes(mode ? c.substring(2) : c) &&
                                c.startsWith(`${mode ? mode + '_' : ''}${prefix}_`)
                            )
                        });
                        const allPrefixColumnsblank = prefixColumns.every(c => !data[c]);
    
                        const cellKey = mode ? (mode + '_' + col) : col
                        var cellValue = ''
                        if (allPrefixColumnsblank) {
                            cellValue = ''
                        } else if (typeof data[cellKey] === 'undefined') {
                            cellValue = 'Not Applicable'
                        } else {
                            cellValue = data[cellKey]
                        }
                        return (
                            <td key={index}>{cellValue}</td>
                        )
                    })}
                </tr>
            )
        })
    )
}
